import { AbstractProgramModel } from "@app/catalog-common";

export class ProgramUpdatedMessage {
    public program: AbstractProgramModel;
    
    constructor(program: AbstractProgramModel)
    {
        this.program = program;
    }
}